// External Dependencies:
import React from 'react'
import { withRouter } from 'react-router-dom'

class Link extends React.Component {
	handleClick = ( e ) => {
		e.preventDefault()

		const { history, to, onClick } = this.props
		let { transitionPrefix } = this.props

		if ( ! transitionPrefix ) {
			transitionPrefix = 'page'
		}

		if ( onClick ) {
			onClick()
		}

		document.documentElement.classList.add( `has-transition-${transitionPrefix}-leaving` )

		setTimeout( () => {
			document.documentElement.classList.remove( `has-transition-${transitionPrefix}-leaving` )

			history.push( to )
		}, 400 )
	}

	render() {
		let { children, to, className, activeClassName, fuzzyMatch, location } = this.props

		if ( fuzzyMatch && location.pathname.indexOf( to ) > -1 ) {
			className += ` ${activeClassName}`
		} else if ( location.pathname == to ) {
			className += ` ${activeClassName}`
		}

		return (
			<a href={ to } className={ className } onClick={ this.handleClick }>{ children }</a>
		)
	}
}

export default withRouter( Link )



// WEBPACK FOOTER //
// ./components/Link/Link.jsx